import useViewWalk from 'lib/hooks/api/useViewWalk'

const useIsUserAuthorized = (
  walkSlug: string,
  enabled?: boolean
): boolean | null => {
  const { data, error } = useViewWalk(walkSlug, enabled)

  if (process.env.NEXT_PUBLIC_USE_SSO !== 'true') {
    return true
  }

  if (data) {
    return true
  }

  if (error) {
    return false
  }

  return null
}

export default useIsUserAuthorized
